import React, {FC, memo} from "react";

const PageNotFound: FC = () => {
    // const {loading} = useSelector((state: IRootState) => state.app)

    return(
        <div style={{display:"flex", justifyContent: "center"}}>
            <h1>Страница не найдена</h1>
        </div>

    )
}
export default memo(PageNotFound)
